import React from 'react';
import { Typography } from '@mui/material';

type CardWeekHeaderProps = {
  day: string;
  date: string;
  headerClasses?: { dayClass?: string; dateClass?: string };
  className?: string;
};

export const CardWeekHeader = ({ day, date, headerClasses, ...props }: CardWeekHeaderProps) => (
  <div {...props}>
    <Typography variant="h4" style={{ textAlign: 'center' }} className={headerClasses?.dayClass}>
      {day}
    </Typography>
    <Typography
      style={!date ? { marginBottom: 31 } : { textAlign: 'center' }}
      variant="subtitle2"
      className={headerClasses?.dateClass}
    >
      {date}
    </Typography>
  </div>
);
